// Button.js
import { PropsWithChildren } from 'react';
import styles from './Section.module.scss'; // Import the SCSS stylesheet
import { Accordion, AccordionContent, AccordionSummary } from '../Accordion/Accordion';

type Props = {
  text: string;
};

const Section: React.FC<PropsWithChildren<Props>> = ({ text, children }) => {
  return (
    <Accordion open>
      <AccordionSummary>
        <h2 className={styles['title']}>{text}</h2>
      </AccordionSummary>
      <AccordionContent>{children}</AccordionContent>
    </Accordion>
  );
};

export default Section;
